import { createApiService, API_CONFIGS } from '../utils/apiService';
import axios from '@configs/axios';

const operations = {
    fetchNews: createApiService(
        (lang) => {
            return axios.get(`/news/all`, {
                headers: { 'x-lang': `${lang}` }
            });
        },
        {
            ...API_CONFIGS.GET_WITH_DATA,
            context: 'News - Fetch All',
            transformResponse: (response) => response // Return full response data
        }
    ),

    fetchNewsDetails: createApiService(
        (newsId = 1, lang) => {
            return axios.get(`/news/detail?id=${newsId}`, {
                headers: { 'x-lang': `${lang}` }
            });
        },
        {
            ...API_CONFIGS.GET_WITH_DATA,
            context: 'News - Fetch Details',
            transformResponse: (response) => response // Return full response data
        }
    )
}
export default operations